//
//
//
//
//
//
//
//
//
//

export default {
  name: 'ReadMore',
  props: {
    maxHeight: {
      type: Number,
      default: 150,
    },
    mobileMaxHeight: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      expanded: false,
      contentOverflows: false,
      currentMaxHeight: 150,
    };
  },
  computed: {
    containerStyle() {
      return {
        overflow: 'hidden',
        transition: 'max-height 0.3s ease',
        maxHeight: this.expanded ? '1000px' : `${this.currentMaxHeight }px`,
      };
    },
    isToggleVisible() {
      return this.contentOverflows;
    },
  },
  mounted() {
    this.setMaxHeight();
    this.checkOverflow();

    window.addEventListener('resize', this.setMaxHeight);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.setMaxHeight);
  },
  methods: {
    setMaxHeight() {
      const width = window.innerWidth;
      this.currentMaxHeight =
          768 >= width && null !== this.mobileMaxHeight
            ? this.mobileMaxHeight
            : this.maxHeight;

      this.$nextTick(() => {
        this.checkOverflow();
      });
    },
    checkOverflow() {
      const { content } = this.$refs;
      if (content) {
        this.contentOverflows = content.scrollHeight > this.currentMaxHeight;
      }
    },
    toggle() {
      this.expanded = !this.expanded;
    },
  },
};
